import { MetricsContextProvider } from 'modules/productAnalytics/context';
import MessagingInsights from '../components/MessagingInsights';
import { MESSAGING_INSIGHTS } from '../constants';
import { AppliedFiltersContextProvider } from './AppliedFiltersContextProvider';
import { CampaignAndMetricFiltersContextProvider } from './CampaignAndMetricFiltersContextProvider';
import { TabContextProvider } from './TabContextProvider';
import { TabSpecificFiltersContextProvider } from './TabSpecificFiltersContextProvider';
import { TimeFiltersContextProvider } from './TimeFiltersContextProvider';
import { ViewContextProvider } from './ViewContextProvider';

export const MessagingInsightsContext = () => {
  return (
    <AppliedFiltersContextProvider>
      <MetricsContextProvider page={MESSAGING_INSIGHTS}>
        <CampaignAndMetricFiltersContextProvider>
          <TimeFiltersContextProvider>
            <TabSpecificFiltersContextProvider>
              <TabContextProvider>
                <ViewContextProvider>
                  <MessagingInsights />
                </ViewContextProvider>
              </TabContextProvider>
            </TabSpecificFiltersContextProvider>
          </TimeFiltersContextProvider>
        </CampaignAndMetricFiltersContextProvider>
      </MetricsContextProvider>
    </AppliedFiltersContextProvider>
  );
};
